import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="text-xs text-slate-300 flex flex-wrap items-center gap-1" data-testid="breadcrumbs">
      {items.map((c, i) => (
        <span key={c.path} className="flex items-center gap-1">
          {i > 0 && <ChevronRight size={12} />}
          {i < items.length - 1 ? <Link to={c.path} className="hover:text-accent">{c.name}</Link> : <span className="text-white">{c.name}</span>}
        </span>
      ))}
    </nav>
  );
}
